"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  properties: {
    step: {
      type: 'number'
    },
    value_type: {
      type: 'string'
    },
    min: {
      type: 'number'
    },
    max: {
      type: 'number'
    }
  }
};
exports.default = _default;